import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export interface V2PermissionsState {
  rbac_enabled: boolean;
  codenames: string[];
  loaded: boolean;
}

const initialState: V2PermissionsState = {
  rbac_enabled: false,
  codenames: [],
  loaded: false,
};

const v2PermissionsSlice = createSlice({
  name: "v2Permissions",
  initialState,
  reducers: {
    setV2Permissions(
      state,
      action: PayloadAction<{ rbac_enabled: boolean; codenames: string[] }>,
    ) {
      state.rbac_enabled = action.payload.rbac_enabled;
      state.codenames = action.payload.codenames;
      state.loaded = true;
    },
    resetV2Permissions(state) {
      state.rbac_enabled = false;
      state.codenames = [];
      state.loaded = false;
    },
  },
});

export const { setV2Permissions, resetV2Permissions } =
  v2PermissionsSlice.actions;

export default v2PermissionsSlice.reducer;
